(() => {
  function enhanceCookieBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.hsProminent) return;
    const body = banner.querySelector('.shopify-pc__banner__body');
    const link = banner.querySelector('#shopify-pc__banner__body-policy-link');
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    if (!body || !link || !accept) return;
    let title = banner.querySelector('#shopify-pc__banner__body-title');
    if (!title) {
      title = document.createElement('h2');
      title.id = 'shopify-pc__banner__body-title';
      body.prepend(title);
    }
    title.textContent = window.HolyTheme?.hs_cookie_text || 'Privacidade e cookies';
    banner.setAttribute('aria-labelledby', title.id);
    if (window.HolyTheme?.hs_cookie_link) link.textContent = window.HolyTheme.hs_cookie_link;
    if (window.HolyTheme?.hs_cookie_accept) accept.textContent = window.HolyTheme.hs_cookie_accept;
    banner.dataset.hsProminent = 'true';
  }
  enhanceCookieBanner();
  new MutationObserver(enhanceCookieBanner).observe(document.body, { childList: true, subtree: true });
})();
